import React, { FC } from 'react';
import { CalendarContainer } from 'react-datepicker';
import { IContainerProps } from '@components/Calendar/types';

export const Container:FC<IContainerProps> = ({ children }) => (
  <CalendarContainer className="calendar">
    {children}
  </CalendarContainer>
);
